<template>
  <div>
    <HeaderPanel
      title="Plugins"
      :filter="filter"
      placeholder=""
      :hasDropdown="false"
      :hasFilter="false"
      :hasSearch="false"
    />

    <div class="bg-white border-red p-2 p-lg-3 mt-3">
      <b-container>
        <b-row style="row-gap: 30px">
          <b-col
            lg="4"
            md="6"
            cols="12"
            v-for="list of data"
            :key="'card-' + list.id"
          >
            <b-card class="rounded-xl" no-body style="overflow: hidden">
              <div class="setting-icon">
                <b-dropdown
                  dropleft
                  right
                  center
                  variant="custom-link"
                  toggle-class="text-decoration-none border-none"
                  no-caret
                >
                  <template #button-content>
                    <font-awesome-icon
                      icon="ellipsis-v"
                      class="color-primary"
                    />
                  </template>
                  <b-dropdown-item
                    @click="$router.push('/setting/plugins/' + list.id)"
                    v-if="[1, 3].includes(list.id)"
                    >Info</b-dropdown-item
                  >
                  <b-dropdown-item
                    @click="$router.push('/setting/plugins/logs/' + list.id)"
                    >Logs</b-dropdown-item
                  >
                  <b-dropdown-item @click="openModal(list)"
                    >Setting</b-dropdown-item
                  >
                </b-dropdown>
              </div>
              <div class="p-3">
                <b-img
                  class="image-logo"
                  :src="list.image_url || default_image"
                  @error="handleImageSrc"
                ></b-img>
                <div class="font-bold mt-2">{{ list.name }}</div>
                <p class="two-lines my-1">
                  {{ list.description }}
                </p>
              </div>
              <template #footer>
                <b-form-checkbox
                  switch
                  class="radio-active"
                  size="md"
                  v-model="list.status"
                  :value="1"
                  @change="updateData(false, list)"
                  :unchecked-value="0"
                >
                  <span class="ml-2 main-label">{{
                    list.status == 1 ? "Active" : "Inactive"
                  }}</span>
                </b-form-checkbox>
              </template>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
      <b-modal v-model="modalShow" title="SETTING" @hidden="clearForm">
        <template v-if="form.is_zort">
          <InputText
            textFloat="URL"
            placeholder="URL"
            type="text"
            name="url"
            v-model="form.url"
            :v="$v.form.url"
            @input="resetUrl"
            :isValidate="$v.form.url.$error"
            isRequired
          />
          <InputText
            textFloat="name"
            placeholder="name"
            type="text"
            name="plugins-name"
            v-model="form.name"
            :v="$v.form.name"
            :isValidate="$v.form.name.$error"
            isRequired
          />
          <InputText
            textFloat="Store Name"
            placeholder="Store Name"
            type="text"
            name="plugins-Store Name"
            v-model="form.storename"
            :v="$v.form.storename"
            :isValidate="$v.form.storename.$error"
            isRequired
          />
          <InputText
            textFloat="API Key"
            placeholder="API Key"
            type="text"
            name="api_key"
            v-model="form.apikey"
            :v="$v.form.apikey"
            :isValidate="$v.form.apikey.$error"
            isRequired
          />
          <InputText
            textFloat="API Secret"
            placeholder="API Secret"
            type="text"
            name="api_key"
            v-model="form.apisecret"
            :v="$v.form.apisecret"
            :isValidate="$v.form.apisecret.$error"
            isRequired
          />
          <InputSelect
            title="Order Status"
            name="Order Status"
            :options="orderStatus"
            v-model="form.order_status"
            valueField="id"
            textField="name"
          >
            <!-- :v="$v.form.order_status"
            :isValidate="$v.form.order_status.$error" -->
            <template v-slot:option-first>
              <b-form-select-option :value="null" disabled
                >--- Select order status ---
              </b-form-select-option>
            </template>
          </InputSelect>
          <InputSelect
            title="Order Payment Status"
            name="Order Payment Status"
            :options="paymentStatus"
            v-model="form.order_paymentstatus"
            valueField="id"
            textField="name"
          >
            <!-- :v="$v.form.order_paymentstatus"
            :isValidate="$v.form.order_paymentstatus.$error" -->
            <template v-slot:option-first>
              <b-form-select-option :value="null" disabled
                >--- Select payment status ---
              </b-form-select-option>
            </template>
          </InputSelect>
        </template>
        <template v-else-if="form.id == 6">
          <InputText
            textFloat="URL"
            placeholder="URL"
            @input="resetUrl"
            type="text"
            name="url"
            v-model="form.url"
            :v="$v.form.url"
            :isValidate="$v.form.url.$error"
            isRequired
          />

          <InputText
            textFloat="Token"
            placeholder="Token"
            type="text"
            name="token"
            v-model="form.token"
            :v="$v.form.token"
            :isValidate="$v.form.token.$error"
            isRequired
          />
          <InputText
            textFloat="Pixel ID."
            placeholder="Pixel ID."
            type="text"
            name="pixel_id"
            v-model="form.pixel_id"
            :v="$v.form.pixel_id"
            :isValidate="$v.form.pixel_id.$error"
            isRequired
          />
          <InputText
            textFloat="Lastest Day"
            placeholder="Lastest Day"
            type="number"
            name="latest_day"
            v-model="form.latest_day"
            :v="$v.form.latest_day"
            :isValidate="$v.form.latest_day.$error"
            isRequired
          />
        </template>
        <template v-else-if="form.id == 7">
          <span class="text-gray">Outlook Email</span>
          <InputText
            :textFloat="'Client ID.'"
            placeholder="Client ID."
            type="text"
            autocomplete="a"
            name="plugins-client-id"
            v-model="form.username"
            :v="$v.form.username"
            :isValidate="$v.form.username.$error"
            isRequired
          />
          <InputText
            textFloat="User ID."
            placeholder="User ID."
            name="plugins-user-id"
            v-model="form.password"
            :v="$v.form.password"
            :isValidate="$v.form.password.$error"
            isRequired
          />
          <InputText
            textFloat="Tenant ID"
            placeholder="Tenant ID"
            type="text"
            name="tenant_id"
            v-model="form.token"
            :v="$v.form.token"
            :isValidate="$v.form.token.$error"
            isRequired
          />
          <InputText
            textFloat="Client Secret"
            placeholder="Client Secret"
            type="text"
            name="client_secret"
            v-model="form.apikey"
            :v="$v.form.apikey"
            :isValidate="$v.form.apikey.$error"
            isRequired
          />
          <b-form-checkbox
            class="color-primary mb-3"
            size="md"
            v-model="form.is_accept_mail"
            :value="1"
            :unchecked-value="0"
          >
            <span class="ml-2 main-label">
              Accept incoming ticket from registered email only
            </span>
          </b-form-checkbox>
          <div class="text-error" v-if="connectionErrorMessage.status">
            {{ connectionErrorMessage.message }}
          </div>
          <div
            class="text-underline cursor-pointer"
            @click="testSendEmailPlugin(true)"
          >
            Test Connection
          </div>
        </template>
        <template v-else-if="form.id == 8">
          <InputText
            textFloat="Username"
            placeholder="Username"
            type="text"
            autocomplete="a"
            name="cache-username"
            v-model="form.username"
            :v="$v.form.username"
            :isValidate="$v.form.username.$error"
            isRequired
          />
          <InputText
            textFloat="Password"
            placeholder="Password"
            name="cache-password"
            v-model="form.password"
            :v="$v.form.password"
            :isValidate="$v.form.password.$error"
            isRequired
          />
          <InputText
            textFloat="Store proc register customer "
            placeholder="Store proc register customer "
            type="text"
            name="plugins-Store_proc_register_customer "
            v-model="form.storename"
            :v="$v.form.storename"
            :isValidate="$v.form.storename.$error"
            isRequired
          />
          <InputText
            textFloat="Store proc update customer by day"
            placeholder="Store proc update customer by day"
            type="text"
            name="plugins-Store_proc_update_customer_by_day"
            v-model="form.storeproc_name"
            :v="$v.form.storeproc_name"
            :isValidate="$v.form.storeproc_name.$error"
            isRequired
          />
          <InputText
            textFloat="Server"
            placeholder="Server"
            type="text"
            name="server"
            v-model="form.server"
            :v="$v.form.server"
            :isValidate="$v.form.server.$error"
            isRequired
          />
          <InputText
            textFloat="Name Space"
            placeholder="Name Space"
            type="text"
            name="name_space"
            v-model="form.name_space"
            :v="$v.form.name_space"
            :isValidate="$v.form.name_space.$error"
            isRequired
          />
          <InputText
            textFloat="Port"
            placeholder="Port"
            type="number"
            name="port"
            v-model="form.port"
            :v="$v.form.port"
            :isValidate="$v.form.port.$error"
            isRequired
          />
        </template>
        <template v-else-if="form.id == 9">
          <InputText
            textFloat="Login ID"
            placeholder="Login ID"
            type="text"
            autocomplete="a"
            name="ls-login-id"
            v-model="form.username"
            :v="$v.form.username"
            :isValidate="$v.form.username.$error"
            isRequired
          />
          <InputText
            textFloat="Password"
            placeholder="Password"
            name="ls-password"
            type="password"
            v-model="form.password"
            :v="$v.form.password"
            :isValidate="$v.form.password.$error"
            isRequired
          />
          <InputText
            textFloat="Client secret"
            placeholder="Client secret"
            type="text"
            name="ls-api-secret"
            v-model="form.apisecret"
            :v="$v.form.apisecret"
            :isValidate="$v.form.apisecret.$error"
            isRequired
          />
          <InputText
            textFloat="Client ID"
            placeholder="Client ID"
            type="text"
            name="ls-client-id"
            v-model="form.apikey"
            :v="$v.form.apikey"
            :isValidate="$v.form.apikey.$error"
            isRequired
          />
          <InputText
            textFloat="Scope"
            placeholder="Scope"
            type="text"
            name="ls-scope"
            v-model="form.key"
            :v="$v.form.key"
            :isValidate="$v.form.key.$error"
            isRequired
          />
          <InputText
            textFloat="Access token url"
            placeholder="Access token url"
            type="text"
            name="Access token url"
            v-model="form.token"
            :v="$v.form.token"
            :isValidate="$v.form.token.$error"
            isRequired
          />
          <InputText
            textFloat="URL."
            placeholder="URL."
            type="text"
            name="ls-url"
            v-model="form.url"
            :v="$v.form.url"
            :isValidate="$v.form.url.$error"
            isRequired
          />
          <InputText
            textFloat="Transaction URL."
            placeholder="Transaction URL."
            type="text"
            name="ls-url"
            v-model="form.url_transaction"
            :v="$v.form.url_transaction"
            :isValidate="$v.form.url_transaction.$error"
            isRequired
          /> </template
        ><template v-else-if="form.id == 10">
          <InputText
            textFloat="URL."
            placeholder="URL."
            type="text"
            name="ls-url"
            v-model="form.url"
            :v="$v.form.url"
            :isValidate="$v.form.url.$error"
            isRequired
          />
          <InputText
            textFloat="Login ID"
            placeholder="Login ID"
            type="text"
            autocomplete="a"
            name="ls-login-id"
            v-model="form.username"
            :v="$v.form.username"
            :isValidate="$v.form.username.$error"
            isRequired
          />
          <InputText
            textFloat="Password"
            placeholder="Password"
            name="ls-password"
            type="password"
            v-model="form.password"
            :v="$v.form.password"
            :isValidate="$v.form.password.$error"
            isRequired
          />
        </template>
        <template v-else>
          <InputText
            textFloat="URL"
            placeholder="URL"
            @input="resetUrl"
            type="text"
            name="url"
            v-model="form.url"
            :v="$v.form.url"
            :isValidate="$v.form.url.$error"
            isRequired
          />
          <InputText
            :textFloat="form.id == 5 ? 'Encrypt Head' : 'Username'"
            placeholder="Username"
            type="text"
            autocomplete="a"
            name="plugins-username"
            v-model="form.username"
            :v="$v.form.username"
            v-if="form.id != 3 && form.id != 4"
            :isValidate="$v.form.username.$error"
            isRequired
          />
          <InputText
            textFloat="Password"
            placeholder="Password"
            type="password"
            name="plugins-password"
            v-model="form.password"
            :v="$v.form.password"
            :isValidate="$v.form.password.$error"
            isRequired
            v-if="form.id != 3 && form.id != 4 && form.id != 5"
          />
          <InputText
            textFloat="Token"
            placeholder="Token"
            type="text"
            name="token"
            v-model="form.token"
            :v="$v.form.token"
            :isValidate="$v.form.token.$error"
            isRequired
            v-if="form.id == 3 || form.id == 4"
          />
          <InputText
            :textFloat="form.id == 5 ? 'Passkey' : 'API Key'"
            :placeholder="form.id == 5 ? 'Passkey' : 'API Key'"
            type="text"
            name="api_key"
            v-model="form.apikey"
            :v="$v.form.apikey"
            :isValidate="$v.form.apikey.$error"
            isRequired
            v-if="form.id != 3 && form.id != 4"
          />
          <InputText
            :textFloat="form.id == 5 ? 'URL Origin' : 'Brand Code'"
            :placeholder="form.id == 5 ? 'URL Origin' : 'Brand Code'"
            type="text"
            name="brand_code"
            v-model="form.brand_code"
            :v="$v.form.brand_code"
            :isValidate="$v.form.brand_code.$error"
            isRequired
            v-if="form.id != 4"
          />

          <InputText
            textFloat="Channel ID"
            placeholder="Channel ID"
            type="text"
            name="channel_id"
            v-model="form.chanel_id"
            :v="$v.form.chanel_id"
            :isValidate="$v.form.chanel_id.$error"
            isRequired
            v-if="form.id != 3 && form.id != 4 && form.id != 5"
          />
          <InputText
            textFloat="Mock Email (if Email is Empty)"
            placeholder="Email"
            type="text"
            name="email-mock"
            v-model="form.mock_email"
            :v="$v.form.mock_email"
            :isValidate="$v.form.mock_email.$error"
            isRequired
            v-if="form.id != 3 && form.id != 4 && form.id != 5"
          />
          <div v-if="form.id != 3 && form.id != 4 && form.id != 5">
            <label class="main-label">
              Mock Birthday (if Birthday is Empty)
              <span class="text-error">*</span>
            </label>
            <div
              :class="[
                'input-container',
                { error: $v.form.mock_birthday.$error },
              ]"
            >
              <datetime
                type="date"
                v-model="form.mock_birthday"
                placeholder="DD/MM/YYYY"
                format="dd/MM/yyyy"
                value-zone="Asia/Bangkok"
                ref="birthdate"
                :isValidate="$v.form.mock_birthday.$error"
                :v="$v.form.mock_birthday"
              >
              </datetime>
              <div
                :class="'icon-primary text-right cursor-default'"
                @click="$refs.birthdate.isOpen = true"
              >
                <font-awesome-icon
                  icon="calendar-alt"
                  :class="'pointer color-primary cursor-default color-primary'"
                  color="#B41BB4"
                />
              </div>
            </div>
          </div>
          <div
            v-if="
              $v.form.mock_birthday.$error &&
              form.id != 3 &&
              form.id != 4 &&
              form.id != 5
            "
          >
            <span
              class="text-error"
              v-if="$v.form.mock_birthday.required == false"
              >Please select date.</span
            >
          </div>
        </template>
        <template #modal-footer>
          <b-row class="w-100 justify-content-between" no-gutters>
            <b-col cols="4">
              <b-button
                block
                @click.prevent="modalShow = false"
                class="border-btn"
                >Cancel</b-button
              >
            </b-col>

            <b-col cols="4">
              <b-button
                block
                class="submit-btn"
                @click.prevent="updateData(true)"
                >Confirm</b-button
              >
            </b-col>
          </b-row>
        </template>
      </b-modal>
    </div>
    <FooterAction routePath="/setting" :hideSubmit="true" />
  </div>
</template>

<script>
import { required, email, requiredIf } from "vuelidate/lib/validators";
const isValidUrl = (string, data) => {
  try {
    if (data.id == 7 || data.id == 8) return true;

    new URL(string);
    return true;
  } catch (err) {
    return false;
  }
};
export default {
  data() {
    return {
      filter: {},
      data: [],
      modalShow: false,
      form: {
        id: 0,
        name: "",
        image_url: null,
        description: null,
        status: 1,
        url: "",
        username: "",
        password: "",
        brand_code: "",
        chanel_id: "",
        mock_email: "",
        mock_birthday: "",
        token: null,
        apisecret: null,
        apikey: null,
        storename: null,
        order_status: null,
        order_paymentstatus: null,
        is_accept_mail: 1,
        port: "",
        server: "",
        name_space: "",
        storeproc_name: "",
      },
      orderStatus: [
        { name: "Pending", id: "Pending" },
        { name: "Success", id: "Success" },
        { name: "Voided", id: "Voided" },
        { name: "Waiting", id: "Waiting" },
        { name: "ไม่ใส่", id: "" },
      ],
      paymentStatus: [
        { name: "Pending", id: "Pending" },
        { name: "Paid", id: "Paid" },
        { name: "Voided", id: "Voided" },
        { name: "Waiting", id: "Waiting" },
        { name: "Partial", id: "Partial" },
        { name: "Overpaid", id: "Overpaid" },
        { name: "ไม่ใส่", id: "" },
      ],
      connectionErrorMessage: {
        message: "",
        status: false,
      },
    };
  },
  validations() {
    return {
      form: {
        url: {
          isValidUrl: (val) => isValidUrl(val, this.form),
          required: requiredIf(function (item) {
            return ![7, 8].includes(item.id);
          }),
        },
        apikey: {
          required: requiredIf(function (item) {
            return [1, 2, 5, 7, 9].includes(item.id);
          }),
        },
        token: {
          required: requiredIf(function (item) {
            return [3, 4, 6, 7, 9].includes(item.id);
          }),
        },
        apisecret: {
          required: requiredIf(function (item) {
            return (item.is_zort && [1, 2].includes(item.id)) || item.id == 9;
          }),
        },
        username: {
          required: requiredIf(function (item) {
            return !item.is_zort && [1, 2, 5, 7, 8, 9, 10].includes(item.id);
          }),
        },
        password: {
          required: requiredIf(function (item) {
            return !item.is_zort && [1, 2, 7, 8, 9, 10].includes(item.id);
          }),
        },
        chanel_id: {
          required: requiredIf(function (item) {
            return !item.is_zort && [1, 2].includes(item.id);
          }),
        },
        brand_code: {
          required: requiredIf(function (item) {
            return !item.is_zort && ![4, 6, 7, 8, 9].includes(item.id);
          }),
        },
        mock_email: {
          required: requiredIf(function (item) {
            return !item.is_zort && [1, 2].includes(item.id);
          }),
          email,
        },
        mock_birthday: {
          required: requiredIf(function (item) {
            return !item.is_zort && [1, 2].includes(item.id);
          }),
        },
        storename: {
          required: requiredIf(function (item) {
            return item.is_zort || [1, 2, 8].includes(item.id);
          }),
        },
        storeproc_name: {
          required: requiredIf(function (item) {
            return item.id == 8;
          }),
        },
        pixel_id: {
          required: requiredIf(function (item) {
            return item.id == 6;
          }),
        },
        latest_day: {
          required: requiredIf(function (item) {
            return item.id == 6;
          }),
        },
        name: {
          required: requiredIf(function (item) {
            return item.is_zort;
          }),
        },
        port: {
          required: requiredIf(function (item) {
            return item.id == 8;
          }),
        },
        server: {
          required: requiredIf(function (item) {
            return item.id == 8;
          }),
        },
        name_space: {
          required: requiredIf(function (item) {
            return item.id == 8;
          }),
        },
        key: {
          required: requiredIf(function (item) {
            return item.id == 9;
          }),
        },
        url_transaction: {
          required: requiredIf(function (item) {
            return item.id == 9;
          }),
        },
      },
    };
  },
  created() {
    this.getData();
    // this.getDataById();
  },
  methods: {
    clearForm() {
      this.$v.form.$reset();
      this.form = {
        id: 0,
        name: "",
        image_url: "",
        description: "",
        status: "",
        url: "",
        username: "",
        password: "",
        brand_code: "",
        chanel_id: "",
        mock_email: "",
        mock_birthday: "",
        key: "",
        token: "",
        port: "",
        server: "",
        name_space: "",
      };
      this.$bus.$emit("hideLoading");
    },
    openModal(form) {
      if (form.id == 2 || form.name.toLowerCase() == "zort") {
        this.getZortDetail();
      } else {
        this.form = { ...form };
      }
      this.modalShow = true;
    },
    async getZortDetail() {
      const res = await this.axios(`/plugin/pluginType/2`);

      // this.data = res.data.detail;
      this.form = res.data.detail;
      this.form.is_zort = true;
    },
    async getData() {
      const res = await this.axios(`/Plugin/GetList`);

      this.data = res.data.detail;
    },

    async updateData(check, list = this.form) {
      try {
        let payload = { ...list };
        payload.is_pdpa = payload.id == 1 ? 1 : 0;
        if (this.form.id != 3)
          payload.mock_birthday = this.$moment(payload.mock_birthday).format(
            "YYYY-MM-DD"
          );

        payload.chanel_id = payload.chanel_id || 0;

        this.$v.form.$touch();

        for (const key in this.$v.form) {
          // if (Object.prototype.hasOwnProperty.call(object, key)) {
          const element = this.$v.form[key].$error;
          if (element) console.log(key, element);

          // }
        }

        if (check && this.$v.form.$error) return;
        this.$bus.$emit("showLoading");
        if (payload.id == 7 && check) {
          const test = await this.testSendEmailPlugin(false);
          if (!test) return;
        }

        const res = await this.axios.put(`/Plugin/pluginType/save`, payload);
        this.$bus.$emit("hideLoading");

        if (res.data.result) {
          this.modalShow = false;
          this.getData();
          this.successAlert();
        } else {
          this.errorAlert(res.data.message);
          this.$bus.$emit("hideLoading");
        }
      } catch (error) {
        console.log(error);
        this.$bus.$emit("hideLoading");
        this.errorAlert(error.message);
      }
    },
    async testSendEmailPlugin(flag = true) {
      return new Promise(async (resolve, reject) => {
        try {
          this.connectionErrorMessage = {
            message: "",
            status: false,
          };
          let payload = { ...this.form };
          payload.is_pdpa = payload.id == 1 ? 1 : 0;
          if (this.form.id != 3)
            payload.mock_birthday = this.$moment(payload.mock_birthday).format(
              "YYYY-MM-DD"
            );

          payload.chanel_id = payload.chanel_id || 0;
          if (flag) this.$bus.$emit("showLoading");
          const res = await this.axios.post(`/plugin/validticketmail`, payload);

          if (flag) this.$bus.$emit("hideLoading");
          if (res.data.result) {
            // this.modalShow = false;
            if (flag) this.successAlert(`Connection Success`);
            // this.getData();
            resolve(true);
          } else {
            this.connectionErrorMessage = {
              message: res.data.message,
              status: true,
            };
            resolve(false);
          }
        } catch (error) {
          this.$bus.$emit("hideLoading");
          this.errorAlert(error.message);
          resolve(false);
        }
      });
    },
    resetUrl(val) {
      this.$v.form.url.$reset();
    },
  },
};
</script>

<style>
.image-logo {
  border-radius: 0.5rem;
  width: 75px;
  height: auto;
  aspect-ratio: 1;
}
.card-footer {
  padding: 0.75rem 1rem;
}
.setting-icon {
  position: absolute;
  top: 10px;
  right: 10px;
}
.dropdown-menu {
  min-width: unset;
  width: max-content;
}
.dropdown-item.active,
.dropdown-item:active {
  text-decoration: none;
  background-color: #fff;
  color: var(--primary-color) !important;
}
</style>
